'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;

var _IBonusApi = require('api/IBonusApi');

var _IBonusApi2 = _interopRequireDefault(_IBonusApi);

var _PIPOApi = require('api/pipo/PIPOApi');

var _PIPOApi2 = _interopRequireDefault(_PIPOApi);

var _IBonusError = require('api/IBonusError');

var _IBonusError2 = _interopRequireDefault(_IBonusError);

var _log = require('helpers/log');

var _config = require('config/config.ibonus');

var _config2 = _interopRequireDefault(_config);

var _Factory = require('Models/Factory');

var _Factory2 = _interopRequireDefault(_Factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var ERROR_USER_INVALID_ACCESS_TOKEN = 'user.invalid_access_token';

var IBonus = (_class = function () {
    function IBonus(client, storage) {
        (0, _classCallCheck3.default)(this, IBonus);

        this.config = {};
        this.storage = storage;
        this.api = new _IBonusApi2.default(client, storage);
        this.pipo = new _PIPOApi2.default(client);

        this.channelId = 0;
        this.profileId = 0;
        this.onlineShopId = 0;
        this.currentAccessToken = '';
    }

    (0, _createClass3.default)(IBonus, [{
        key: 'onRefresh',
        value: function onRefresh(callback) {
            var _this = this;

            if (this.access_token) {
                return callback().then(function (res) {
                    return res;
                }, function (err) {
                    if (err.title && err.title === ERROR_USER_INVALID_ACCESS_TOKEN) {
                        if (_this.refresh_token) {
                            return _this.api.user.updateAccessToken({
                                client_id: _config2.default.client_id,
                                client_secret: _config2.default.client_secret,
                                refresh_token: _this.refresh_token
                            }).then(function (result) {
                                if (result.access_token) {
                                    _this.access_token = result.access_token;
                                }
                                if (result.refresh_token) {
                                    _this.refresh_token = result.refresh_token;
                                }
                                return callback();
                            }, function (err) {
                                _this.access_token = null;
                                _this.refresh_token = null;
                                throw err;
                            });
                        }
                    }

                    throw err;
                });
            }

            console.log('\n\nREFRESH_TOKEN_ERROR\n\n');

            return _promise2.default.reject({
                code: 301
            });
        }
    }, {
        key: 'userAuthentication',
        value: function userAuthentication(username, password) {
            var captcha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            return _promise2.default.all([this.api.user.authentication({
                username: username,
                password: password,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                captcha: captcha,
                shopId: shopId
            })]
            //this.pipo.login(username, password)
            ).then(function (result) {
                var _result = (0, _slicedToArray3.default)(result, 1),
                    resultIRetail = _result[0];

                resultIRetail.api_key = 'TbFWtJ3oTxFOzQeF8spkDNAv'; //не используется, выпилить
                resultIRetail.pipo_user_id = resultIRetail.user_id;

                return resultIRetail;
            });
        }
    }, {
        key: 'userRegistration',
        value: function userRegistration(password, shopId, params) {
            return this.api.user.register((0, _extends3.default)({
                password: password,
                shopId: shopId
            }, params));
        }
    }, {
        key: 'userConfirmRegistration',
        value: function userConfirmRegistration(_password, _shopId, _params) {
            var _ModelFactory$create = _Factory2.default.create('ConfirmRegistrationRequest', (0, _extends3.default)({
                shopId: _shopId,
                password: _password
            }, _params)),
                password = _ModelFactory$create.password,
                shopId = _ModelFactory$create.shopId,
                params = (0, _objectWithoutProperties3.default)(_ModelFactory$create, ['password', 'shopId']);

            return this.api.user.confirmRegister((0, _extends3.default)({
                password: password,
                shopId: shopId
            }, params)).then(function (result) {
                var message = [];

                if (result === true) {
                    return result;
                } else {
                    if (result.errorCodePhone) {
                        message.push('Проверочный код из смс введён неверно. Повторите попытку.');
                    }

                    if (result.errorCodeEmail) {
                        message.push('Проверочный код, отправленный на email, введён неверно. Повторите попытку.');
                    }

                    throw new _IBonusError2.default({
                        message: message.length === 2 ? message : message[0],
                        title: 'Неверный проверочный код',
                        code: '',
                        trace: ''
                    });
                }
            });
        }
    }, {
        key: 'userRegistrationOneClick',
        value: function userRegistrationOneClick(shopId, params) {
            return this.api.user.registerOneClick((0, _extends3.default)({
                shopId: shopId
            }, params));
        }
    }, {
        key: 'userConfirmRegistrationOneClick',
        value: function userConfirmRegistrationOneClick(shopId, params) {
            return this.api.user.confirmRegisterOneClick((0, _extends3.default)({
                shopId: shopId
            }, params)).then(function (result) {
                var message = [];
                if (result.access_token) {
                    return result;
                } else {
                    if (result.errorCodePhone) {
                        message.push('Проверочный код из смс введён неверно. Повторите попытку.');
                    }

                    if (result.errorCodeEmail) {
                        message.push('Проверочный код, отправленный на email, введён неверно. Повторите попытку.');
                    }

                    throw new _IBonusError2.default({
                        message: message.length === 2 ? message : message[0],
                        title: 'Неверный проверочный код',
                        code: '',
                        trace: ''
                    });
                }
            });
        }

        /**
         *Отправка СМС для востановления пароля
         */

    }, {
        key: 'passRecoverySend',
        value: function passRecoverySend(login, id_shop) {
            return this.api.user.sendCode({ login: login, id_shop: id_shop });
        }
    }, {
        key: 'getPaymentsParamsFromPIPObyId',
        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
            return this.pipo.getPaymentsParamsFromPIPObyId(shopPipoId);
        }
    }, {
        key: 'sendVoiceCode',
        value: function sendVoiceCode(login, source, phone) {
            return this.api.user.sendVoiceCode({ login: login, source: source, phone: phone });
        }
    }, {
        key: 'userRestorePassword',
        value: function userRestorePassword(login, newPassword, code) {
            return this.api.user.restorePassword({
                code: code,
                login: login,
                new_password: newPassword,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                remember_me: true
            }).then(function (result) {
                if (!result) {
                    throw new _IBonusError2.default({
                        message: 'Проверочный код введён неверно. Повторите попытку.',
                        title: 'Неверный проверочный код',
                        code: '',
                        trace: ''
                    });
                } else {
                    return result;
                }
            });
        }
    }, {
        key: 'getUserData',
        value: function getUserData() {
            var _this2 = this;

            var access_token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (access_token !== '' && access_token !== null) {
                this.access_token = access_token;
                this.storage.setItem('access_token', access_token);
            } else {
                access_token = this.access_token;
            }
            return this.onRefresh(function () {
                return _this2.api.user.getData({
                    access_token: access_token || _this2.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    channel_id: _this2.channelId
                });
            });
        }
    }, {
        key: 'getWishList',
        value: function getWishList(wish_list) {
            var access_token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.api.user.getWishList({
                access_token: access_token || this.access_token,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                wish_list: wish_list
            });
        }
    }, {
        key: 'setWishList',
        value: function setWishList(wish_list) {
            return this.api.user.setWishList({
                access_token: this.access_token,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                wish_list: wish_list
            }).catch(function (error) {
                return null;
            });
        }
    }, {
        key: 'userLogout',
        value: function userLogout() {
            return this.api.user.logout({
                access_token: this.access_token,
                refresh_token: this.refresh_token,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret
            });
        }

        /**
         * @returns {Promise}
         */

    }, {
        key: 'getCatalog',
        value: function getCatalog() {
            return this.api.offer.getCategoryByProfile({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId,
                ignore_empty_categories: true
            });
        }

        /**
         * @returns {Promise}
         */

    }, {
        key: 'getPayment',
        value: function getPayment() {
            return this.api.offer.getPaymentMethods({
                channel_id: this.channelId
            });
        }

        /**
         * @returns {Promise}
         */

    }, {
        key: 'getCategories',
        value: function getCategories() {
            return this.api.offer.getCategoryByProfile({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId,
                ignore_empty_categories: true
            }).then(function (result) {
                return result;

                var filterCategories = function filterCategories(category) {

                    if (!category.show_in_catalog) {
                        return null;
                    }

                    if (category.children.length) {
                        category.categories = category.children.map(filterCategories).filter(function (item) {
                            return item;
                        }); //удаление null
                    }
                    delete category.children;

                    return category;
                };

                for (var key in result) {
                    if (result[key].children) {
                        return result[key].children.map(filterCategories);
                    }
                }

                return result.map(filterCategories);
            });
        }
    }, {
        key: 'getProductByCategory',
        value: function getProductByCategory(category_id, page_number, page_size) {
            var _this3 = this;

            var params = {
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId,
                page_number: page_number,
                page_size: page_size
            };

            if (/\D/.test(category_id)) {
                //если хоть один символ не число
                return this.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
            }
            return this.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { category_id: category_id })).then(function (result) {
                return result;
            }, function (error) {
                if (error.code == 139) {
                    //если товар не найден пробуем по ЧПУ
                    return _this3.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
                }
                throw error;
            });
        }
    }, {
        key: 'getByCategory',
        value: function getByCategory(category_id, page_number, page_size) {
            var _this4 = this;

            var params = {
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId,
                page_number: page_number,
                page_size: page_size
            };

            if (/\D/.test(category_id)) {
                //если хоть один символ не число
                return this.api.offer.getInCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
            }
            return this.api.offer.getInCategory((0, _extends3.default)({}, params, { category_id: category_id })).then(function (result) {
                return result;
            }, function (error) {
                if (error.code == 139) {
                    //если товар не найден пробуем по ЧПУ
                    return _this4.api.offer.getInCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
                }
                throw error;
            });
        }
    }, {
        key: 'getCategoryRecommended',
        value: function getCategoryRecommended(category_id) {
            var params = {
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId,
                category_id: category_id
            };
            return this.api.offer.getCategoryRecommended(params);
        }
    }, {
        key: 'getProductById',
        value: function getProductById(id) {
            var _this5 = this;

            var params = {
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                profile_id: this.profileId
            };

            if (/\D/.test(id)) {
                //если хоть один символ не число
                return this.api.offer.getById((0, _extends3.default)({}, params, { semantic_url: id }));
            }
            return this.api.offer.getById((0, _extends3.default)({}, params, { offer_id: id })).then(function (result) {
                return result;
            }, function (error) {
                if (error.code == 109) {
                    return _this5.api.offer.getById((0, _extends3.default)({}, params, { semantic_url: id }));
                }
                throw error;
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
            var categories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
            var begin_time_create = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var end_time_create = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var begin_time_update = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            var end_time_update = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

            return this.api.offer.get({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channels: [this.channelId],
                profile_id: this.profileId,
                name: name,
                page_number: page_number,
                page_size: page_size,
                categories: categories,
                begin_time_create: begin_time_create,
                end_time_create: end_time_create,
                begin_time_update: begin_time_update,
                end_time_update: end_time_update
            });
        }
    }, {
        key: 'orderCreate',
        value: function orderCreate(sum) {
            var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var user_agent = arguments[2];
            var utm_redirect_data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
            var currency_id = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 643;

            var _this6 = this;

            var delivery_address = arguments[5];
            var custom_fields = arguments[6];
            //currency_id = 643 id валюты
            return this.onRefresh(function () {
                return _this6.api.user.order.create({
                    channel_id: _this6.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    access_token: _this6.access_token,
                    currency_id: currency_id,
                    time_create: new Date().toUTCString(),
                    utm_redirect_data: utm_redirect_data,
                    delivery_address: delivery_address,
                    sum: sum,
                    products: products,
                    user_agent: user_agent,
                    custom_fields: custom_fields
                }).then(function (result) {
                    return result;
                    // return this.paymentCreate(result.order_id);
                });
            });
        }
    }, {
        key: 'editOrder',
        value: function editOrder(order_id, sum) {
            var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var user_agent = arguments[3];

            var _this7 = this;

            var utm_redirect_data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
            var currency_id = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 643;
            //currency_id = 643 id валюты
            return this.onRefresh(function () {
                return _this7.api.user.order.edit({
                    order_id: order_id,
                    channel_id: _this7.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    access_token: _this7.access_token,
                    currency_id: currency_id,
                    time_create: new Date().toUTCString(),
                    utm_redirect_data: utm_redirect_data,
                    sum: sum,
                    products: products,
                    user_agent: user_agent
                }).then(function (result) {
                    return result;
                    // return this.paymentCreate(result.order_id);
                });
            });
        }

        /**
         * Создание нового счёта для заказа
         */

    }, {
        key: 'paymentCreate',
        value: function paymentCreate(order_id) {
            var _this8 = this;

            return this.onRefresh(function () {
                return _this8.api.user.order.pay({
                    order_id: order_id,
                    access_token: _this8.access_token,
                    channel_id: _this8.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'getOrders',
        value: function getOrders(page_number, page_size) {
            var _this9 = this;

            return this.onRefresh(function () {
                return _this9.api.user.order.get({
                    page_number: page_number,
                    page_size: page_size,
                    channel: _this9.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    access_token: _this9.access_token
                });
            });
        }
    }, {
        key: 'getOrderById',
        value: function getOrderById(id) {
            var _this10 = this;

            return this.onRefresh(function () {
                return _this10.api.user.order.get({
                    channel: _this10.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    access_token: _this10.access_token,
                    number: parseInt(id, 10) || 0
                }).then(function (result) {
                    if (result.orders) {
                        if (result.count) {
                            return result.orders[0];
                        } else {
                            return null;
                            throw new _IBonusError2.default({
                                message: 'Страница не существует',
                                title: 'Страница не существует',
                                code: '404',
                                trace: ''
                            });
                        }
                    }
                    return result;
                });
            });
        }

        /**
         *Метод для редактирования заказа
         */

    }, {
        key: 'setOrder',
        value: function setOrder(order_id, client_comment, service_in_slug, delivery_address) {
            var _this11 = this;

            return this.onRefresh(function () {
                return _this11.api.user.order.set({
                    order_id: order_id,
                    client_comment: client_comment,
                    service_in_slug: service_in_slug,
                    delivery_address: delivery_address,
                    access_token: _this11.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'setPayOrder',
        value: function setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders) {
            var _this12 = this;

            var captcha = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;

            return this.onRefresh(function () {
                return _this12.api.user.order.setPayOrder({
                    order_id: order_id,
                    client_comment: client_comment,
                    service_in_slug: service_in_slug,
                    delivery_address: delivery_address,
                    access_token: _this12.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    discount_sum: discount_sum,
                    coupon_id: coupon_id,
                    coupon_token: coupon_token,
                    customer_coupon_id: customer_coupon_id,
                    custom_fields: custom_fields,
                    child_orders: child_orders,
                    captcha: captcha
                });
            });
        }
    }, {
        key: 'cancelOrder',
        value: function cancelOrder(order_id) {
            var _this13 = this;

            return this.onRefresh(function () {
                return _this13.api.user.order.cancel({
                    order_id: order_id,
                    channel_id: _this13.channelId,
                    access_token: _this13.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'payInnerPipo',
        value: function payInnerPipo(accountId, operationId) {
            var _this14 = this;

            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this.onRefresh(function () {
                return _this14.api.user.paymentIn.pay({
                    account_id: accountId,
                    operation_id: operationId,
                    access_token: _this14.access_token,
                    channel_id: _this14.channelId,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    check_code: checkCode
                });
            });
        }
    }, {
        key: 'checkCodeConfirmForPayInnerPipo',
        value: function checkCodeConfirmForPayInnerPipo(online_shop_id, orderId) {
            var _this15 = this;

            return this.onRefresh(function () {
                return _this15.api.user.paymentIn.beforePay({
                    access_token: _this15.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    online_shop_id: _this15.onlineShopId,
                    order_id: orderId
                });
            });
        }
    }, {
        key: 'paymentServices',
        value: function paymentServices(paymentInId, user_id, api_key) {
            return this.pipo.getInputGroupsByPaymentInId(paymentInId, this.storage.getItem('pipo_user_id'), this.storage.getItem('api_key'));
        }
    }, {
        key: 'getDetailPayIn',
        value: function getDetailPayIn(operationId) {
            return this.pipo.getDetailPayIn(operationId, this.storage.getItem('pipo_user_id'), this.storage.getItem('api_key'));
        }

        /**
         * Пулучение выписки по счёту для пользователя
         */

    }, {
        key: 'getPipoOperations',
        value: function getPipoOperations(date_begin, date_end, id_account, page, page_size) {
            var _this16 = this;

            return this.onRefresh(function () {
                return _this16.api.user.getPipoOperations({
                    date_begin: date_begin,
                    date_end: date_end,
                    id_account: id_account,
                    page: page,
                    page_size: page_size,
                    channel_id: _this16.channelId,
                    access_token: _this16.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }

        /**
         * Получение настроек магазина по доменному имени
         *
         * @param {String} domain
         *
         * @return {Promise}
         */

    }, {
        key: 'getDomainInfo',
        value: function getDomainInfo(domain) {
            domain = domain ? domain : _config2.default.localhost || this.api.client.req && this.api.client.req.hostname;

            return this.api.user.channel.getOnlineShopSettings({ domain: domain }).then(function (result) {
                if (result === null) {
                    throw new Error('Not found domain: ' + domain);
                }
                return result;
            });
        }
    }, {
        key: 'getPageDetail',
        value: function getPageDetail(page_id, online_shop_id) {
            return this.api.user.onlineShop.getPageById({ page_id: page_id, online_shop_id: online_shop_id });
        }

        /**
         * Получение списка товаров для слайдера
         */

    }, {
        key: 'getProductForSlider',
        value: function getProductForSlider(type) {
            return this.api.offer.getSliderOfferByType({
                type: type,
                profile_id: this.profileId,
                channel_id: this.channelId
            });
        }

        /**
         * Получение списка категорий для слайдера
         */

    }, {
        key: 'getCategoryForSlider',
        value: function getCategoryForSlider() {
            return this.api.offer.getSliderByCategory({
                profile_id: this.profileId
            });
        }
    }, {
        key: 'getLang',
        value: function getLang(lang) {
            return this.pipo.getLang(lang);
        }
    }, {
        key: 'pipoProcessInput',
        value: function pipoProcessInput(operation_id, group_slug) {
            var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            var params = {
                operation_id: operation_id,
                group_slug: group_slug,
                json: 1
            };
            if (additionalFieldName && additionalFieldText) {
                params[additionalFieldName] = additionalFieldText;
            }
            return this.pipo.processInput(params);
        }
    }, {
        key: 'changeName',
        value: function changeName(pipoId, name, newName, access_token) {
            var _this17 = this;

            return this.onRefresh(function () {
                return _this17.api.user.changeName({
                    pipo_id: pipoId,
                    name: name,
                    new_name: newName,
                    access_token: access_token || _this17.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'changeMail',
        value: function changeMail(pipoId, newEmail, code, access_token) {
            var _this18 = this;

            return this.onRefresh(function () {
                return _this18.api.user.changeMail({
                    pipo_id: pipoId,
                    new_email: newEmail,
                    code: code,
                    access_token: access_token || _this18.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'changeMailWithCode',
        value: function changeMailWithCode(pipoId, newEmail, code, access_token) {
            var _this19 = this;

            return this.onRefresh(function () {
                return _this19.api.user.changeMailWithCode({
                    pipo_id: pipoId,
                    new_email: newEmail,
                    code: code,
                    access_token: access_token || _this19.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                }).then(function (result, err) {
                    if (!result) {
                        throw new _IBonusError2.default({
                            message: 'Проверочный код введён неверно. Повторите попытку.',
                            title: 'Неверный проверочный код',
                            code: '',
                            trace: ''
                        });
                    } else {
                        return result;
                    }
                });
            });
        }
    }, {
        key: 'changePhone',
        value: function changePhone(pipoId, newPhone, code, access_token) {
            var _this20 = this;

            //let numberPhone = Number(newPhone.replace(/\D+/g,""));
            return this.onRefresh(function () {
                return _this20.api.user.changePhone({
                    pipo_id: pipoId,
                    new_phone: newPhone,
                    code: code,
                    access_token: access_token || _this20.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'changePhoneWithCode',
        value: function changePhoneWithCode(pipoId, newPhone, code, access_token) {
            var _this21 = this;

            //let numberPhone = Number(newPhone.replace(/\D+/g,""));
            return this.onRefresh(function () {
                return _this21.api.user.changePhoneWithCode({
                    pipo_id: pipoId,
                    new_phone: newPhone,
                    code: code,
                    access_token: access_token || _this21.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                }).then(function (result) {
                    if (!result) {
                        throw new _IBonusError2.default({
                            message: 'Проверочный код введён неверно. Повторите попытку.',
                            title: 'Неверный проверочный код',
                            code: '',
                            trace: ''
                        });
                    } else {
                        return result;
                    }
                });
            });
        }
    }, {
        key: 'confirmPhone',
        value: function confirmPhone(pipoId, phone, code, access_token) {
            var _this22 = this;

            //let numberPhone = Number(phone.replace(/\D+/g,""));
            return this.onRefresh(function () {
                return _this22.api.user.confirmPhone({
                    pipo_id: pipoId,
                    phone: phone,
                    code: code,
                    access_token: access_token || _this22.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'confirmPhoneWithCode',
        value: function confirmPhoneWithCode(pipoId, phone, code, access_token) {
            var _this23 = this;

            //let numberPhone = Number(phone.replace(/\D+/g,""));
            return this.onRefresh(function () {
                return _this23.api.user.confirmPhoneWithCode({
                    pipo_id: pipoId,
                    phone: phone,
                    code: code,
                    access_token: access_token || _this23.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                }).then(function (result) {
                    if (!result) {
                        throw new _IBonusError2.default({
                            message: 'Проверочный код введён неверно. Повторите попытку.',
                            title: 'Неверный проверочный код',
                            code: '',
                            trace: ''
                        });
                    } else {
                        return result;
                    }
                });
            });
        }
    }, {
        key: 'confirmMail',
        value: function confirmMail(pipoId, email, code, access_token) {
            var _this24 = this;

            return this.onRefresh(function () {
                return _this24.api.user.confirmMail({
                    pipo_id: pipoId,
                    email: email,
                    code: code,
                    access_token: access_token || _this24.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'confirmMailWithCode',
        value: function confirmMailWithCode(pipoId, email, code, access_token) {
            var _this25 = this;

            return this.onRefresh(function () {
                return _this25.api.user.confirmMailWithCode({
                    pipo_id: pipoId,
                    email: email,
                    code: code,
                    access_token: access_token || _this25.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                }).then(function (result) {
                    if (!result) {
                        throw new _IBonusError2.default({
                            message: 'Проверочный код введён неверно. Повторите попытку.',
                            title: 'Неверный проверочный код',
                            code: '',
                            trace: ''
                        });
                    } else {
                        return result;
                    }
                });
            });
        }
    }, {
        key: 'confirmEMailBySignature',
        value: function confirmEMailBySignature(order_id, confirm_signature) {
            return this.api.user.confirmEMailBySignature({
                access_token: this.access_token,
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                order_id: order_id,
                confirm_signature: confirm_signature
            });
        }
    }, {
        key: 'changePassword',
        value: function changePassword(login, newPassword, newRepassword, oldPassword, access_token) {
            var _this26 = this;

            return this.onRefresh(function () {
                return _this26.api.user.changePassword({
                    login: login,
                    new_password: newPassword,
                    new_repassword: newRepassword,
                    old_password: oldPassword,
                    access_token: access_token || _this26.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                }).then(function (result) {
                    if (!result) {
                        throw new _IBonusError2.default({
                            message: 'Повторите попытку.',
                            title: 'Не удалось сменить пароль',
                            code: '',
                            trace: ''
                        });
                    } else {
                        return result;
                    }
                });
            });
        }
    }, {
        key: 'shareBasket',
        value: function shareBasket(basket, customFields) {
            return this.api.offer.shareBasket({
                channel_id: this.channelId,
                products: basket,
                custom_fields: customFields
            });
        }
    }, {
        key: 'postponeBasket',
        value: function postponeBasket(basket, customFields) {
            return this.api.user.postponeBasket({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                access_token: this.access_token,
                channel_id: this.channelId,
                products: basket,
                custom_fields: customFields
            });
        }
    }, {
        key: 'getPostpone',
        value: function getPostpone() {
            return this.api.user.getPostpone({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                access_token: this.access_token,
                channel_id: this.channelId
            });
        }
    }, {
        key: 'deletePostpone',
        value: function deletePostpone(id) {
            return this.api.user.deletePostpone({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                access_token: this.access_token,
                channel_id: this.channelId,
                id: id
            });
        }
    }, {
        key: 'mergePostpone',
        value: function mergePostpone(mergeIds) {
            return this.api.user.mergePostpone({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                access_token: this.access_token,
                channel_id: this.channelId,
                merge_ids: mergeIds
            });
        }
    }, {
        key: 'getSharedBasket',
        value: function getSharedBasket(code) {
            return this.api.offer.getSharedBasket({
                code: code
            }).then(function (res) {
                if (res) {
                    // res.cartItems.forEach((item) => {
                    //    if (item.modifierOption) {
                    //        item.offer.modifier_option_id = item.modifierOption.id;
                    //        item.offer.modifier_option = item.modifierOption;
                    //    }
                    // });
                    return res;
                }
                throw new _IBonusError2.default({
                    message: 'Нет такой корзины',
                    title: 'Нет такой корзины',
                    code: '404',
                    trace: ''
                });
            });
        }
    }, {
        key: 'getActualPrices',
        value: function getActualPrices(basketElements) {
            return this.api.offer.getActualPrices({
                products: basketElements,
                channel_id: this.channelId
            });
        }
    }, {
        key: 'getCouponsByToken',
        value: function getCouponsByToken(token) {
            var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var params = {
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId,
                token: token,
                user_id: user_id
            };
            return this.api.offer.getCouponsByToken(params);
        }
    }, {
        key: 'updateInn',
        value: function updateInn(inn, access_token) {
            var _this27 = this;

            return this.onRefresh(function () {
                return _this27.api.user.updateInn({
                    access_token: access_token || _this27.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    inn: inn
                });
            });
        }
    }, {
        key: 'updateUlName',
        value: function updateUlName(ul_name, access_token) {
            var _this28 = this;

            return this.onRefresh(function () {
                return _this28.api.user.updateUlName({
                    access_token: access_token || _this28.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    ul_name: ul_name
                });
            });
        }
    }, {
        key: 'getAddresses',
        value: function getAddresses(access_token) {
            var _this29 = this;

            return this.onRefresh(function () {
                return _this29.api.user.loadAddresses({
                    access_token: access_token || _this29.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'updateAddress',
        value: function updateAddress(id, address, is_default, access_token) {
            var _this30 = this;

            return this.onRefresh(function () {
                return _this30.api.user.updateAddress({
                    access_token: access_token || _this30.access_token,
                    id: id,
                    address: address,
                    is_default: is_default,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'deleteAddress',
        value: function deleteAddress(id, access_token) {
            var _this31 = this;

            return this.onRefresh(function () {
                return _this31.api.user.deleteAddress({
                    access_token: access_token || _this31.access_token,
                    id: id,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret
                });
            });
        }
    }, {
        key: 'addAddress',
        value: function addAddress(address, access_token) {
            var _this32 = this;

            return this.onRefresh(function () {
                return _this32.api.user.addAddress({
                    access_token: access_token || _this32.access_token,
                    client_id: _config2.default.client_id,
                    client_secret: _config2.default.client_secret,
                    address: address
                });
            });
        }
    }, {
        key: 'getLangData',
        value: function getLangData() {
            return this.api.lang.getLangData();
        }
    }, {
        key: 'getChannelLastUpdateDate',
        value: function getChannelLastUpdateDate() {
            return this.api.channel.getLastUpdateDate({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId
            });
        }
    }, {
        key: 'getChannelActualCatalogLabel',
        value: function getChannelActualCatalogLabel() {
            return this.api.channel.getActualCatalogLabel({
                client_id: _config2.default.client_id,
                client_secret: _config2.default.client_secret,
                channel_id: this.channelId
            });
        }
    }, {
        key: 'access_token',
        get: function get() {
            return this.storage.getItem('access_token') ? this.storage.getItem('access_token') : this.currentAccessToken;
        },
        set: function set(value) {
            if (value != null && value !== '') {
                this.currentAccessToken = value;
                this.storage.setItem('access_token', value);
            }
        }
    }, {
        key: 'refresh_token',
        get: function get() {
            return this.storage.getItem('refresh_token');
        },
        set: function set(value) {
            this.storage.setItem('refresh_token', value);
        }

        /**
         * Обёртка для методов с access токеном
         * @param callback
         * @returns {Request|Promise.<TResult>|*}
         */

    }]);
    return IBonus;
}(), (_applyDecoratedDescriptor(_class.prototype, 'onRefresh', [_log.log], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRefresh'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getProductById', [_log.log], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getProductById'), _class.prototype)), _class);
exports.default = IBonus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/api/IBonus.js
// module id = 1590
// module chunks = 0